export const vh100 = 'var(--vh, 1vh) * 100';
